const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};
const formatter = new Intl.DateTimeFormat('en-US', options);

/**
 * Format date with pattern: MM/DD/YYYY hh:mm
 * @param date
 * @returns
 */
const formatDateTime = (date: Date | string) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return formatter.format(date).replace(',', '');
};

const DateHelper = {
  formatDateTime,
};
export default DateHelper;
